import React, { useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Icon } from '@doxyme/ui';
import { useSelector } from 'react-redux';
import './sidebar-footer.scss';
import { AccountMenu } from '../account-menu';
import { selectUser } from '../../../../store/features/system';
import { UserSubscriptionType } from '../../../core';
export const SidebarFooter = () => {
    const user = useSelector(selectUser);
    const isFreeUser = useMemo(() => user === null || user.subscriptionType === UserSubscriptionType.Free, [user]);
    const clickUpgradeAccountHandler = useCallback(() => {
        history.pushState(null, null, '/account/subscription');
    }, []);
    return (<div className="sidebar-footer-react" data-test-id="sidebar-footer-react">
      {isFreeUser && (<Button data-test-id="sidebar-upgrade-to-pro-btn" className="sidebar-footer-react-upgrade-btn" color="warning" size="medium" startIcon={<Icon name="star" size="x-small"/>} onClick={clickUpgradeAccountHandler}>
          <FormattedMessage id="common.upgrade" defaultMessage="Upgrade"/>
        </Button>)}
      <AccountMenu />
    </div>);
};
